export default __webpack_public_path__ + "static/media/Plissee 22 mm seitlich ausmessen front.412b66fb.jpg";